import { render, staticRenderFns } from "./BrochuresModal.vue?vue&type=template&id=c2ced5be&"
import script from "./BrochuresModal.vue?vue&type=script&lang=js&"
export * from "./BrochuresModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2ced5be')) {
      api.createRecord('c2ced5be', component.options)
    } else {
      api.reload('c2ced5be', component.options)
    }
    module.hot.accept("./BrochuresModal.vue?vue&type=template&id=c2ced5be&", function () {
      api.rerender('c2ced5be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/modals/BrochuresModal.vue"
export default component.exports